export default "__VITE_ASSET__B2WkVG4O__"